import { useGlobalStateStore } from "../../stores/store";

// This component is used to show the comparison popup
const ComparisonPopup = ({ onClick, text = "Compare odds" }) => {
  const store = useGlobalStateStore();
  const isShowPopup = store.selectedBetPopupDisplayed;
  const mode = store.getMode();

  // Hide popup instantly if mode is 'selectedBet'
  if (mode === "selectedBet") return null;

  return (
    <a
      href="#"
      id="add-to-comparison-popup"
      className={`add-to-comparison-popup ${isShowPopup ? "show" : ""}`}
      onClick={onClick}
    >
      <span> {text}</span>
      <div>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_322_1213)">
            <path
              d="M5.00007 10.7144H1.42864C1.2392 10.7144 1.05752 10.7896 0.923565 10.9236C0.78961 11.0575 0.714355 11.2392 0.714355 11.4286V18.5715C0.714355 18.7609 0.78961 18.9426 0.923565 19.0766C1.05752 19.2105 1.2392 19.2858 1.42864 19.2858H5.00007C5.18951 19.2858 5.37119 19.2105 5.50515 19.0766C5.6391 18.9426 5.71436 18.7609 5.71436 18.5715V11.4286C5.71436 11.2392 5.6391 11.0575 5.50515 10.9236C5.37119 10.7896 5.18951 10.7144 5.00007 10.7144ZM4.28578 17.8572H2.14293V12.1429H4.28578V17.8572Z"
              fill="#FF8000"
            />
            <path
              d="M11.7857 5.71436H8.21429C8.02485 5.71436 7.84316 5.78961 7.70921 5.92357C7.57526 6.05752 7.5 6.2392 7.5 6.42864V18.5715C7.5 18.7609 7.57526 18.9426 7.70921 19.0766C7.84316 19.2105 8.02485 19.2858 8.21429 19.2858H11.7857C11.9752 19.2858 12.1568 19.2105 12.2908 19.0766C12.4247 18.9426 12.5 18.7609 12.5 18.5715V6.42864C12.5 6.2392 12.4247 6.05752 12.2908 5.92357C12.1568 5.78961 11.9752 5.71436 11.7857 5.71436ZM11.0714 17.8572H8.92857V7.14293H11.0714V17.8572Z"
              fill="#FF8000"
            />
            <path
              d="M18.5714 0.714355H14.9999C14.8105 0.714355 14.6288 0.78961 14.4949 0.923565C14.3609 1.05752 14.2856 1.2392 14.2856 1.42864V18.5715C14.2856 18.7609 14.3609 18.9426 14.4949 19.0766C14.6288 19.2105 14.8105 19.2858 14.9999 19.2858H18.5714C18.7608 19.2858 18.9425 19.2105 19.0764 19.0766C19.2104 18.9426 19.2856 18.7609 19.2856 18.5715V1.42864C19.2856 1.2392 19.2104 1.05752 19.0764 0.923565C18.9425 0.78961 18.7608 0.714355 18.5714 0.714355ZM17.8571 17.8572H15.7142V2.14293H17.8571V17.8572Z"
              fill="#FF8000"
            />
          </g>
          <defs>
            <clipPath id="clip0_322_1213">
              <rect width="20" height="20" fill="#FF8000" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </a>
  );
};

export default ComparisonPopup;
